import { render, staticRenderFns } from "./MyDFC.vue?vue&type=template&id=ab667962&scoped=true"
import script from "./MyDFC.vue?vue&type=script&lang=js"
export * from "./MyDFC.vue?vue&type=script&lang=js"
import style0 from "./MyDFC.vue?vue&type=style&index=0&id=ab667962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab667962",
  null
  
)

export default component.exports